var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgButtonArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 10,
    viewBox: "0 0 11 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.7518 3.97995C9.92029 4.15398 10.0151 4.39088 10.0151 4.63801C10.0151 4.88514 9.92029 5.12203 9.7518 5.29606L6.19185 9.00341C6.02608 9.17464 5.80233 9.27117 5.56886 9.2722C5.33229 9.27362 5.10492 9.17691 4.93696 9.00341C4.76848 8.82939 4.67371 8.59249 4.67371 8.34536C4.67371 8.09823 4.76848 7.86133 4.93696 7.6873L7.86503 4.63801L4.95476 1.58871C4.72901 1.35361 4.64084 1.01094 4.72347 0.689787C4.80611 0.368634 5.04698 0.117784 5.35537 0.0317317C5.66375 -0.0543211 5.99279 0.0374961 6.21855 0.272597L9.7518 3.97995Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-0.00012207 4.65033C-0.00012207 4.17008 0.389196 3.78076 0.869443 3.78076H7.36481C7.84506 3.78076 8.23438 4.17008 8.23438 4.65033C8.23438 5.13057 7.84506 5.51989 7.36481 5.51989H0.869444C0.389196 5.51989 -0.00012207 5.13057 -0.00012207 4.65033Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonArrow);
export default __webpack_public_path__ + "static/media/button-arrow.4de90e5b59c0e67ace3ddfcc9d9b3bfb.svg";
export { ForwardRef as ReactComponent };